import { FC } from 'react'
import { IDataListProps } from './types'
import sharedStyles from '@muiscss/sharedStyles.module.scss'
import styles from './styles.module.scss'
import clsx from 'clsx'

const Input: FC<IDataListProps> = ({
  autoFocus = false,
  disabled = false,
  hasError,
  id,
  label,
  name,
  onBlur,
  onChange,
  onFocus,
  options,
  placeholder = 'search',
  required,
  size = 'md',
  slots,
  style,
  transparent = false,
  ...props
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selected = options.find((option) => option.label === event.currentTarget.value)
    if (!selected) return
    event.currentTarget.id = selected.id
    event.target.id = selected.id
    onChange?.(event)
  }
  return (
    <div className={styles.inputHolder}>
      {label && (
        <label
          className={clsx('mui-datalist-label', sharedStyles.label, sharedStyles[size], {
            [sharedStyles.disabled]: disabled,
          })}
          data-testid="mui-label"
          htmlFor={id}
        >
          {label} {required && '*'}
        </label>
      )}

      <div className={styles.innerHolder}>
        {slots?.before && (
          <span
            className={clsx(styles.slotsBefore, styles[size], {
              [sharedStyles.inputError]: hasError,
              [styles.withSlotsAfter]: Boolean(slots?.after),
              [styles.transparent]: transparent,
            })}
          >
            {slots.before}
          </span>
        )}

        <input
          autoFocus={autoFocus}
          className={clsx('mui-datalist', styles.input, styles[size], {
            [sharedStyles.inputError]: hasError,
            [styles.withSlotsBefore]: Boolean(slots?.before),
            [styles.withSlotsAfter]: Boolean(slots?.after),
            [styles.transparent]: transparent,
          })}
          data-testid="mui-datalist"
          disabled={disabled}
          id={id}
          list={name}
          name={name}
          placeholder={placeholder}
          required={required}
          style={{ ...style }}
          onBlur={(event: React.FocusEvent<HTMLInputElement>) => onBlur?.(event)}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleChange(event)}
          onFocus={(event: React.FocusEvent<HTMLInputElement>) => onFocus?.(event)}
          {...props}
        />

        <datalist id={name}>
          {options?.map((option) => {
            return <option {...option}>{option.label}</option>
          })}
        </datalist>

        {slots?.after && (
          <span
            className={clsx(styles.slotsAfter, styles[size], {
              [sharedStyles.inputError]: hasError,
              [styles.withSlotsBefore]: Boolean(slots?.before),
              [styles.transparent]: transparent,
            })}
          >
            {slots.after}
          </span>
        )}
      </div>
    </div>
  )
}

export default Input
